module.exports = __webpack_public_path__ + "img/Flag_of_Angola.ea0a5987.svg";